import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reload',
  templateUrl: './reload.component.html',
  styles: [
  ]
})
export class ReloadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
